module.exports = __webpack_public_path__ + "static/monkey_768-40-80a5117096722cd6c49dc6c1750405ff.jpg";